define(function (require) {
    'use strict';

    var _ = require('underscore');
    var Marionette = require('marionette');
    var I18n = require('i18n!nls/main');

    var template = require('text!./index.tpl').default;
    var itemTemplate = require('text!./item.tpl').default;
    var EmptyView = require('parts/rightbar_empty');
    var StaffCallContactPopover = require('popovers/staff_call_to_contact/view');
    var SmsEditPopover = require('popovers/sms_edit/view');
    var EmailEditPopover = require('modals/email_edit/view');
    var EmailModel       = require('models/email');
    var PopoverBehavior         = require('behaviors/popover');
    var ModalBehavior         = require('behaviors/modal');
    var AppConfig = require('config/application');
    // var MissedCallsCollection = require('collections/missed_calls');
    var HeaderModel = require('models/header_alerts');

    var Model = Backbone.Model.extend({});

    var ItemView = Marionette.ItemView.extend({
        template: itemTemplate,
        className: 'missed-calls__list scrollbar-macosx'
    });

    return Marionette.LayoutView.extend({
        template: template,

        regions: {
            regionList: '.js-region-list'
        },

        ui: {
            // 'deleteCall': '.js-delete-call',
            // 'collapseProject': '.js-collapse-project',
            // 'clearAll': '.js-clear',
            // 'singleProject': '.js-single-project',
            // 'allProjects': '.js-all-projects',
            // 'missedItem': '.js-missed-item',
            // 'callBtn': '.js-contact-phone-call',
            // 'smsBtn': '.js-contact-sendsms',
            // 'emailBtn': '.js-contact-sendemail',
            'projectCallsBtn': '.js-project-calls'
        },

        events: {
            // 'click @ui.deleteCall': 'deleteCall',
            // 'click @ui.collapseProject': 'collapseProject',
            // 'click @ui.clearAll': 'clearAll',
            // 'click @ui.singleProject': 'singleProject',
            // 'click @ui.allProjects': 'allProjects',
            // 'click @ui.missedItem': 'openContact',
            // 'mousedown  @ui.callBtn': 'onPressPhoneCall',
            // 'click @ui.callBtn': 'stopBubling',
            // 'click @ui.smsBtn': 'onClickSendSms',
            // 'click @ui.emailBtn': 'onClickSendEmail',
            'click @ui.projectCallsBtn': 'onClickProjectCallsBtn'
        },

        behaviors: {
            'popover': {
                behaviorClass: PopoverBehavior
            },
            'modal': {
                behaviorClass: ModalBehavior
            }
        },

        initialize: function () {
            this.model = new Model();
            this.headerModel = new HeaderModel();
            // this.collection =  new MissedCallsCollection();
            // this.listenTo(this.collection, 'sync', this.transform_collection);
            this.listenTo(this.headerModel, 'sync', this.transform_collection);
            this.cur_project = 0;
        },

        onShow: function() {
            this.headerModel.fetch()
                .then(() => {
                    this.transform_collection();
                    this.$('[data-toggle="tooltip"]').tooltip({
                        container: 'body'
                    });
                });
        },

        onRender: function () {
            // this.transform_collection(this.collection);
            // this.$('[data-toggle="tooltip"]').tooltip({
            //     container: 'body'
            // });
        },

        onClickProjectCallsBtn: function(event) {
            var projectId = $(event.currentTarget).data('id');
            var def = new $.Deferred();

            if (projectId != app.Models.curProject.id) {
                try {
                    sessionStorage.setItem('projectId', projectId)
                } catch (e) {
                }
                Backbone.ajax({
                    type: 'POST',
                    url: AppConfig.host + '/rest/system/change_project/' + projectId,
                    success: function () {
                        // window.location.reload();
                        def.resolve();
                    }
                });
            } else {
                def.resolve();
            }

            def.then(() => {
                window.history.replaceState({}, document.title, location.origin + encodeURI('#leads?filter={"missed_calls":[{"id":1,"text":"Да","hidden":"missed_calls"}]}'));
                window.location.reload();
            })
        },

        // openContact: function (event) {
        //     var contactId = $(event.currentTarget).data('contact-id');
        //     var projectId = $(event.currentTarget).data('project-id');
        //     window.location.href = '/#contacts/card/' + contactId;
        //     $('.js-btn-calls').click();
        //     if (projectId != app.Models.curProject.id) {
        //         Backbone.ajax({
        //             type: 'POST',
        //             url: AppConfig.host + '/rest/system/change_project/' + projectId,
        //             success: function () {
        //                 if ('caches' in window) {
        //                     caches.keys()
        //                         .then(function (cacheNames) {
        //                             cacheNames.map(function (cacheName) {
        //                                 if (cacheName == 'lptracker-data-v2') {
        //                                     caches
        //                                         .delete(cacheName)
        //                                         .catch(function(error) {
        //                                             console.warn('Caches delete failed with ' + error);
        //                                         });
        //                                 }
        //                             })
        //                         })
        //                         .catch(function(error) {
        //                             console.warn('Caches keys failed with ' + error);
        //                         });
        //                 }
        //                 window.location.reload();
        //             }
        //         });
        //     }
        // },

        /**
         * transfer collection to array to export on template
         */
        transform_collection: function (collection) {
            var that = this;
            if(that.regionList == undefined) {
                return;
            }

            // var items = {}, project_id, project_name, project;

            // //that.collection = collection;
            // app.Collections.Projects.forEach((model) => {
            //     items[model.id] = {
            //         name: model.get('name'),
            //         calls: [],
            //     }
            // })
            // if (collection.length > 0) {
                // _.each(that.collection.models, function (model, i) {
                //     // if (that.cur_project == 0) {
                //     //     project_id = model.get('project_id');
                //     //     project = app.Collections.Projects.get(project_id);
                //     //     if(project) {
                //     //         project_name = project.get('name');
                //     //     }
                //     // } else {
                //     //     if (model.get('project_id') == that.cur_project) {
                //     //         project = app.Collections.Projects.get(that.cur_project);
                //     //         if(project) {
                //     //             project_name = project.get('name');
                //     //         }
                //     //     } else {
                //     //         return;
                //     //     }
                //     // }

                //     // if (project_name !== undefined) {
                //     //     if (typeof items[project_name] == 'undefined') items[project_name] = [];

                //     if (items[model.get('project_id')]) {
                //         items[model.get('project_id')].calls.push({
                //             id: model.get('id'),
                //             call_type: model.get('call_type'),
                //             date: model.get('date'),
                //             number: model.get('number'),
                //             contact_name: model.get('contact_name'),
                //             contact_id: model.get('contact_id'),
                //             project_id: model.get('project_id'),
                //             delete_access: model.get('delete_access')
                //         });
                //     }
                //     // }
                // });
                // that.model.set({items: items});
            that.regionList.show(new ItemView({ model: that.headerModel}));
            // } else {
                // that.regionList.show(new EmptyView());
            // }
            this.$el.lptSetter();
        },

        /**
         * removing single alert
         */
        // deleteCall: function (e) {
        //     var that = this;
        //     var id = $(e.currentTarget).data('id');
        //     var model = this.collection.get(id);

        //     e.stopPropagation();
        //     Backbone.ajax({
        //         url: AppConfig.host + '/rest/missed-calls',
        //         dataType: 'JSON',
        //         type: 'DELETE',
        //         data: JSON.stringify({
        //             id: id
        //         }),
        //         success: function (response) {
        //             if (response.status == 1 && !that.isDestroyed) {
        //                 $(e.currentTarget).closest('.b-notice__block').hide();

        //                 app.Vents.trigger('miss_calls:delete');
        //             }
        //         },
        //         error: function(xhr){
        //             if(xhr.responseText != ''){
        //                 var response = $.parseJSON(xhr.responseText);
        //                 app.message.error(response.message || 'Ошибка');
        //             }
        //         }
        //     });
        // },

        /**
         * hide or show alerts
         */
        collapseProject: function (e) {
            $(e.currentTarget).children('span').toggle();
            this.$('.b-notice__block').toggle();
        },

        /**
         * remove all alerts
         */
        clearAll: function () {
            var that = this;

            Backbone.ajax({
                url: AppConfig.host + '/rest/contacts/all-missed-calls',
                dataType: 'JSON',
                type: 'DELETE',
                data: JSON.stringify({
                    site_id: this.cur_project
                }),

                success: function (response) {
                    if (response.status == 1 && !that.isDestroyed) {
                        that.$('.b-mc__body').addClass('animated fadeOutRight');
                        app.message.success('Список пропущенных звонков очищен.');
                        app.Vents.trigger('miss_calls:delete');
                    }
                },
                error: function(xhr){
                    if(xhr.responseText != ''){
                        var response = $.parseJSON(xhr.responseText);
                        app.message.error(response.message || 'Ошибка');
                    }
                }
            });
        },

        /**
         * filter by all projects
         */
        // allProjects: function () {
        //     this.$('.js-all-projects').addClass('active');
        //     this.$('.js-single-project').removeClass('active');

        //     this.cur_project = 0;

        //     this.transform_collection(this.collection);
        // },

        /**
         * filter by single project
         */
        // singleProject: function () {
        //     this.$('.js-single-project').addClass('active');
        //     this.$('.js-all-projects').removeClass('active');

        //     this.cur_project = app.currentProjectId;

        //     this.transform_collection(this.collection);
        // },

        stopBubling: function(event) {
            event.stopPropagation();
        },

        // onPressPhoneCall: function (event) {
        //     var that = this;
        //     var startTime = Date.now();
        //     var target = event.currentTarget;
        //     var timeout = setTimeout(function () {
        //         var handler = function (widget) {
        //             that.listenToOnce(widget, 'employee:selected', function (data) {
        //                 that.phoneCall.call(that, event, data.employee, data.type);
        //             })
        //         };
        //         that.triggerMethod('showPopover', {
        //             view: StaffCallContactPopover,
        //             target: target,
        //             handler: handler
        //         });
        //     }, 1000);
        //     event.stopPropagation();
        //     event.preventDefault();
        //     $(event.currentTarget).one('mouseup', function (e) {
        //         event.stopPropagation();
        //         var stopTime = Date.now();
        //         var duration = stopTime - startTime;
        //         if (duration <= 1000) {
        //             clearTimeout(timeout);
        //             that.phoneCall.call(that, event);
        //         }
        //     })
        // },

        // phoneCall: function (e, employee, type) {
        //     e.stopPropagation();
        //     e.preventDefault();

        //     var that = this;
        //     var target = $(e.currentTarget);
        //     var id = target.data('id');
        //     var missCall = this.collection.get(id);
        //     var number = missCall && missCall.get('number');
        //     var callType;
        //     var data;

        //     if (type !== undefined) {
        //         callType = type;
        //     } else if (app.Models.User.get('calls_to_sip')) {
        //         callType = 0;
        //     } else if (app.Models.User.get('calls_to_mobile')) {
        //         callType = 1;
        //     } else if(app.Models.User.get('calls_to_sim')) {
        //         callType = 2;
        //     }

        //     data = {
        //         call_type: callType,
        //         phone: number
        //     };

        //     if (employee) {
        //         data.user_id = employee.id;
        //         data.user_type = employee.get('profile_type');
        //     }

        //     app.checkCallTime('phone', data.phone, function(){
        //         Backbone.ajax({
        //             url: AppConfig.host + '/rest/contacts/call_to_number',
        //             type: 'POST',
        //             contentType: 'application/json',
        //             data: JSON.stringify(data),
        //             success: function (response) {
        //                 if (~~response.status === 1) {
        //                     if (!employee) {
        //                         app.message.success(response.message);
        //                     } else {
        //                         app.message.success('Звонок отправлен сотруднику');
        //                     }
        //                 } else {
        //                     app.message.error(response.message);
        //                 }
        //             },
        //             error: function (xhr) {
        //                 var response = $.parseJSON(xhr.responseText);
        //                 app.message.error(response.message || 'Ошибка');
        //             }
        //         });
        //     });
        // },

        // onClickSendSms: function(event) {
        //     var that = this;
        //     var target = $(event.currentTarget);
        //     var id = ''+target.data('contactId');
        //     event.stopPropagation();
        //     this.triggerMethod('showPopover', {
        //         view: SmsEditPopover,
        //         target: target,
        //         handler: function(widget) {
        //             that.listenToOnce(widget, 'sms:edited', function(message) {
        //                 var data = {
        //                     contact_ids: id,
        //                     text: message
        //                 };
        //                 that.sendSms.call(that, data);
        //             })
        //         }
        //     });
        // },

        // onClickSendEmail: function(event) {
        //     var that = this;
        //     var target = $(event.currentTarget);
        //     var model = new EmailModel();
        //     var id = ''+target.data('contactId');
        //     event.stopPropagation();
        //     var dialog = new EmailEditPopover({
        //         curElement: $(target),
        //         modalData: {
        //             model: model
        //         }
        //     });
        //     this.triggerMethod('showModal', dialog);
        //     this.listenToOnce(dialog, 'email:edited', function (isHtml) {
        //         var data = {
        //             contact_ids: id,
        //             subject: model.get('subject'),
        //             text: model.get('text'),
        //             type: isHtml ? 'html' : 'text'
        //         };
        //         if(model.get('from')) {
        //             data.from = model.get('from')
        //         }
        //         that.sendEmail.call(that, data);
        //     })
        // },

        // sendSms: function(data) {
        //     if(data.contact_ids.length) {
        //         var msg = app.message.success('Отправка Sms', false);
        //         this._xhr = Backbone.ajax({
        //             url: AppConfig.host + '/rest/contacts/sms',
        //             contentType: 'application/json',
        //             type: 'POST',
        //             data: JSON.stringify(data),
        //             success: function (response) {
        //                 msg.hide();
        //             },
        //             error: function (xhr) {
        //                 var data = xhr.responseJSON;
        //                 app.message.error(data.message);
        //             }
        //         });
        //     } else {
        //         app.message.error('Нет выбранных номеров');
        //     }
        // },

        // sendEmail: function(data) {
        //     if (data.contact_ids.length) {
        //         var msg = app.message.success('Отправка Email', false);
        //         this._xhr = Backbone.ajax({
        //             url: AppConfig.host + '/rest/contacts/email',
        //             contentType: 'application/json',
        //             type: 'POST',
        //             data: JSON.stringify(data),
        //             success: function (response) {
        //                 msg.hide();
        //                 if (response.status !== 1) {
        //                     app.message.error(response.message);
        //                 }
        //             },
        //             error: function (xhr) {
        //                 var data = xhr.responseJSON;
        //                 app.message.error(data.message);
        //             }
        //         });
        //     } else {
        //         app.message.error('Нет выбранных email адресов');
        //     }
        // }
    })
});
